<template>
	<v-container
		fluid
		class="pa-0"
	>
		<v-app-bar
			v-if="intBreakPoint >= 2"
			fixed
			:class="{ 'navbar-black': isScrolled }"
			class="mt-2 mx-15"
			style="
				border-radius: 10px;
				height: 107px;
				background-color: #f15c24;
				box-shadow: none !important;
			"
		>
			<v-toolbar-title>
				<v-img
					src="../assets/home/logobranco.webp"
					@click="goToTop"
					class="mt-10"
				/>
			</v-toolbar-title>

			<v-spacer></v-spacer>

			<div
				class="d-flex align-center justify-center inter mt-14 mr-8"
				style="gap: 30px"
			>
				<p
					:class="{
						hovernavbar: !isScrolled,
						'hovernavbar-scrolled': isScrolled,
					}"
					style="color: #fff; cursor: pointer"
					@click="scrollToSection('home')"
				>
					Home
				</p>
				<!-- <p :class="{ 'hovernavbar': !isScrolled, 'hovernavbar-scrolled': isScrolled }"
                    style="color: #fff; cursor: pointer;" @click="scrollToSection('sobre')">Sobre nós</p>
                <p :class="{ 'hovernavbar': !isScrolled, 'hovernavbar-scrolled': isScrolled }"
                    style="color: #fff; cursor: pointer;" @click="scrollToSection('beneficios')">Benefícios</p> -->
				<p
					:class="{
						hovernavbar: !isScrolled,
						'hovernavbar-scrolled': isScrolled,
					}"
					style="color: #fff; cursor: pointer"
					@click="scrollToSection('planos')"
				>
					Planos
				</p>
				<p
					:class="{
						hovernavbar: !isScrolled,
						'hovernavbar-scrolled': isScrolled,
					}"
					style="color: #fff; cursor: pointer"
					@click="scrollToSection('FAQ')"
				>
					FAQ
				</p>
				<p
					:class="{
						hovernavbar: !isScrolled,
						'hovernavbar-scrolled': isScrolled,
					}"
					style="color: #fff; cursor: pointer"
					@click="scrollToSection('planos')"
				>
					Cadastre-se
				</p>
			</div>
			<v-btn
				to="/login"
				style="
					background-color: #fff;
					border-radius: 30px;
					width: 110px;
					height: 47px;
					color: #f15a24;
					font-weight: 600;
					font-size: 18px;
				"
				class="mt-10"
				:class="{ 'button-black': isScrolled }"
			>
				Entrar
			</v-btn>
		</v-app-bar>

		<v-app-bar
			fixed
			v-if="intBreakPoint < 2"
			style="max-width: 100vw; background-color: #f15c24; height: 60px"
		>
			<v-toolbar-title
				><v-img
					width="120px"
					src="../assets/home/logobranco.webp"
			/></v-toolbar-title>
			<v-spacer></v-spacer>
			<v-btn
				icon
				style="margin: 0px"
				@click="drawer = true"
			>
				<v-icon
					color="white"
					size="30"
					>mdi-menu</v-icon
				>
			</v-btn>
		</v-app-bar>

		<v-navigation-drawer
			v-if="intBreakPoint <= 2"
			fixed
			style="padding: 20px"
			v-model="drawer"
		>
			<v-row
				class="d-flex flex-column justify-start"
				style="gap: 1rem; padding: 20px"
			>
				<v-toolbar-title
					><v-img
						width="150px"
						src="../assets/logo.png"
				/></v-toolbar-title>
				<div
					class="d-flex justify-center flex-column inter mt-14 mr-8"
					style="gap: 20px"
				>
					<p
						:class="{
							hovernavbar: !isScrolled,
							'hovernavbar-scrolled': isScrolled,
						}"
						style="color: #272727; cursor: pointer"
						@click="
							scrollToSection('home');
							drawer = false;
						"
					>
						Home
					</p>
					<p
						:class="{
							hovernavbar: !isScrolled,
							'hovernavbar-scrolled': isScrolled,
						}"
						style="color: #272727; cursor: pointer"
						@click="
							scrollToSection('beneficios');
							drawer = false;
						"
					>
						Benefícios
					</p>
					<p
						:class="{
							hovernavbar: !isScrolled,
							'hovernavbar-scrolled': isScrolled,
						}"
						style="color: #272727; cursor: pointer"
						@click="
							scrollToSection('planos');
							drawer = false;
						"
					>
						Planos
					</p>
					<p
						:class="{
							hovernavbar: !isScrolled,
							'hovernavbar-scrolled': isScrolled,
						}"
						style="color: #272727; cursor: pointer"
						@click="
							scrollToSection('FAQ');
							drawer = false;
						"
					>
						FAQ
					</p>
					<p
						:class="{
							hovernavbar: !isScrolled,
							'hovernavbar-scrolled': isScrolled,
						}"
						style="color: #272727; cursor: pointer"
						@click="
							scrollToSection('planos');
							drawer = false;
						"
					>
						Cadastre-se
					</p>
					<v-btn
						to="login"
						dark
						style="background-color: #f15a24; color: white !important"
					>
						<v-icon color="white">mdi-account</v-icon> Entrar
					</v-btn>
				</div>
			</v-row>
		</v-navigation-drawer>
		<v-main>
			<v-container fluid>
				<v-row
					style="min-height: 100vh"
					class="bgg d-flex align-center mt-10 justify-center"
				>
					<v-col
						cols="12"
						md="6"
						class="d-flex justify-end align-center"
						id="home"
					>
						<img
							src="../assets/home/firstimg.svg"
							alt="Vade-Mécum"
							style="width: 90%"
						/>
					</v-col>

					<v-col
						cols="12"
						md="6"
						class="d-flex justify-center flex-column inter"
					>
						<h1
							style="
								color: #272727;
								line-height: 1;
								font-size: 50px;
								font-weight: 500;
							"
							class="inter"
						>
							<span style="font-weight: 900">Muito mais</span> do que só <br />
							um
							<span style="color: #f15a24; font-weight: 900"
								>vade-mécum digital.</span
							>
						</h1>
						<p
							class="inter pt-4"
							style="color: #272727; line-height: 23px; font-size: 20px"
						>
							Crie os seus vade-mécuns personalizados. Inclua <br />
							anotações, mídias e links em cada dispositivo legal, <br />
							compartilhe e importe comentários na rede social jurídica. <br />
							<span style="font-weight: 700"
								>Organize os seus documentos no mesmo lugar.</span
							>
						</p>
						<div class="mt-4">
							<div class="d-flex inter flex-column">
								<div class="d-flex">
									<img
										src="../assets/home/peoplee.svg"
										alt="Pessoas"
									/>
									<p
										class="pl-3"
										style="color: #0e0729"
									>
										Compartilhe conhecimento <br />
										na <span style="font-weight: 700">nossa rede social.</span>
									</p>
								</div>
								<router-link to="/cadastro/plano-free">
								<button
									style="
										background-color: #f15c24;
										color: #fff;
										height: 56px;
										width: 265px;
										border-radius: 100px;
										font-size: 17px;
										font-weight: 700;
									"
									class="mt-4 btnblack"
									
								>
									<v-icon
										color="#Fff"
										class="pr-2"
										size="30"
										>mdi-play-circle-outline</v-icon
									>Cadastre-se agora grátis!
								</button>
								</router-link>
							</div>

							<div class="d-flex align-end justify-end mt-5 mr-4">
								<button
									@click="
										verContato = true;
										typeSelected = 1;
									"
									style="
										width: 228px;
										height: 40px;
										background-color: #4d7c31;
										color: #fff;
										border-radius: 100px;
										font-size: 13px;
										font-weight: 600;
									"
								>
									Dúvidas e sugestões? Entre em contato
								</button>
							</div>
						</div>
					</v-col>
					<v-col
						cols="12"
						sm="2"
					>
						<v-carousel
							height="220"
							v-model="showBannerDestaque"
							cycle
							:interval="6000"
							hide-delimiters
							:show-arrows="false"
						>
							<small style="font-size: 10px !important">Patrocínio</small>
							<v-carousel-item
								v-for="b in banners"
								:key="b.directus_files_id"
							>
								<a
									:href="b.link"
									target="_blank"
								>
									<v-img
										:src="`https://api.mylegis.com.br/assets/${b.directus_files_id}`"
										class="mx-auto mb-10"
										width="300"
										contain
										height="250"
									/>
								</a>
							</v-carousel-item>
						</v-carousel>
					</v-col>
					<v-col
						cols="12"
						sm="10"
						class="text-center"
					>
						<!-- <p style="
                font-size: 30px;
                color: #272727;
                margin-bottom: 0;
                font-weight: 500;
                line-height: 1.1;
              ">
              Faça uma pesquisa rápida em nossas
              <span style="font-weight: 900">legislações</span>
            </p> -->

						<!-- <input type="text" v-model="search1" /> -->
						<!-- <v-autocomplete clearable :filter="customFilter" :items="legislacoes" :search-input.sync="search"
              :loading="loading" solo v-model="strSearchLegiscao" item-text="nome_lei" item-value="id_lei"
              color="#F15A24" outlined class=" mx-auto py-1 d-flex align-center justify-center" style="
                background-color: transparent;
                border-radius: 100px;
                width: 80%;
              " placeholder="Pesquise pelo número (10.406) ou palavra da ementa (Código Civil)"
              hint="Pesquise pelo número (10.406) ou palavra da ementa (Código Civil)" hide-details
              label="Pesquise pelo número (10.406) ou palavra da ementa (Código Civil)">
              <template v-slot:no-data>
                <v-list-item>
                  <v-list-item-title>
                    Pesquise pelo número ou palavra da ementa da
                    <strong>legislação</strong>
                  </v-list-item-title>
                </v-list-item>
              </template>
              <template v-slot:item="{ item }">
                <v-list-item-avatar
                                    color="indigo"
                                    class="text-h5 font-weight-light white--text"
                                    >
                                        {{ item.nome_lei.charAt(0) }}
                                    </v-list-item-avatar>
                <v-list-item-content style="max-width: 310px">
                  <v-list-item-title v-html="highlight(item.numero_lei, search)"></v-list-item-title>
                  <div class="text--primary mb-4" v-html="highlight(item.nome_lei, search)"></div>
                  <v-list-item-subtitle v-html="item.nome_lei"></v-list-item-subtitle>
                </v-list-item-content>
                <v-list-item-action>
                  <v-icon>mdi-bitcoin</v-icon>
                </v-list-item-action>
              </template>
            </v-autocomplete> -->
						<!-- <PesquisaLegislacao></PesquisaLegislacao> -->
					</v-col>
				</v-row>
			</v-container>
			<v-container fluid>
				<v-row>
					<v-col
						cols="12"
						class="text-center"
					>
						<p
							style="
								font-size: 40px;
								color: #272727;
								font-weight: 500;
								line-height: 1.1;
							"
						>
							Parceiros
							<span style="font-weight: 900">oficiais</span>
						</p>
					</v-col>
					<v-col
						cols="12"
						sm="12"
						class="text-center"
					>
						<v-slide-group
							class="mb-4 justify-center d-flex"
							cycle
							:interval="4000"
						>
							<v-slide-item
								:class="intBreakPoint < 2 ? `mx-10` : `mx-10`"
								v-for="b in parceiros"
								:key="b.directus_files_id.id"
							>
								<v-hover v-slot="{ hover }">
									<a
										:href="b.link"
										target="_blank"
									>
										<v-img
											:src="`https://api.mylegis.com.br/assets/${b.directus_files_id.id}`"
											class="mx-auto"
											width="320"
											cover
											max-height="100"
										>
											<v-expand-transition>
												<div
													v-if="hover"
													class="d-flex transition-fast-in-fast-out v-card--reveal white--text"
													style="height: 100%"
												>
													{{ b.directus_files_id.description }}
												</div>
											</v-expand-transition>
										</v-img>
									</a>
								</v-hover>
							</v-slide-item>
						</v-slide-group>
					</v-col>
					<!-- <v-col cols="12" sm="4" class="text-center">
            <a href="https://migalhas.com.br" target="_blanck">
              <v-img class="mx-auto" width="300px" height="150px" contain src="../assets/migalhas.svg" />
            </a>
          </v-col> -->
				</v-row>
			</v-container>

			<v-container fluid>
				<v-row id="FAQ">
					<v-col
						cols="12"
						class="text-center"
					>
						<p
							style="
								font-size: 40px;
								color: #272727;
								font-weight: 500;
								line-height: 1.1;
							"
						>
							<span style="font-weight: 900">Perguntas</span> Frequentes
						</p>
					</v-col>
					<v-col
						cols="12"
						md="12"
						class="d-flex align-center justify-center inter"
					>
						<v-slide-group
							:show-arrows="true"
							style="margin-top: 20px"
						>
							<v-slide-item
								class="bgcard pa-3 mr-2"
								v-for="(p, index) in faq"
								:key="p.pergunta"
								style="
									width: 200px;
									display: flex;
									flex-direction: column;
									cursor: pointer;
									justify-content: space-between;
									height: 100%;
								"
							>
								<div
									@click="
										verFaq = true;
										showFaq = index;
									"
								>
									<p
										style="
											color: #fff;
											font-size: 17px;
											font-weight: 700;
											line-height: 25px;
										"
										v-html="p.pergunta"
									></p>
									<p style="color: #fff">Saiba mais</p>
								</div>
							</v-slide-item>
						</v-slide-group>
					</v-col>
				</v-row>
				<v-row class="inter mt-15 pb-16">
					<v-col
						cols="12"
						md="12"
						class="d-flex flex-column align-center justify-center"
					>
						<p
							style="
								font-size: 40px;
								color: #272727;
								font-weight: 500;
								line-height: 1.1;
							"
						>
							Para quem é a
							<span style="font-weight: 900">plataforma Mylegis?</span>
						</p>
						<p
							style="
								font-size: 15px;
								color: #272727;
								font-weight: 400;
								margin-top: -10px;
							"
						>
							Destinado a todos os operadores do Direito ou interessados no
							estudo de legislações.
						</p>
					</v-col>

					<v-col
						cols="12"
						sm="6"
						md="4"
						class="d-flex align-center justify-center"
					>
						<v-hover v-slot="{ hover }">
							<div
								class="image-container d-flex flex-column align-center justify-center"
							>
								<img
									class="primary-image"
									:src="
										!hover
											? require(`../assets/who/themisColor.png`)
											: require(`../assets/who/themisColor.png`)
									"
									alt="Themis Juíza"
									style="width: 324px; height: 274px"
								/>

								<p
									id="paragraph"
									:style="{ color: !hover ? `#4D4D4D` : `#F15C24` }"
									style="color: #4d4d4d; font-size: 22px; font-weight: 800"
								>
									Themis
								</p>
								<p
									style="
										color: #4d4d4d;
										font-size: 15px;
										font-weight: 600;
										margin-top: -20px;
									"
								>
									Juíza
								</p>
							</div>
						</v-hover>
					</v-col>
					<v-col
						cols="12"
						sm="6"
						md="4"
						class="d-flex align-center justify-center"
					>
						<v-hover v-slot="{ hover }">
							<div
								class="image-container d-flex flex-column align-center justify-center"
							>
								<img
									class="primary-image"
									:src="
										!hover
											? require(`../assets/who/mevioColor.png`)
											: require(`../assets/who/mevioColor.png`)
									"
									alt="Mévio Advogado"
									style="width: 324px; height: 274px"
								/>
								<p
									id="paragraph2"
									:style="{ color: !hover ? `#4D4D4D` : `#F15C24` }"
									style="color: #4d4d4d; font-size: 22px; font-weight: 800"
								>
									Mévio
								</p>
								<p
									style="
										color: #4d4d4d;
										font-size: 15px;
										font-weight: 600;
										margin-top: -20px;
									"
								>
									Advogado
								</p>
							</div>
						</v-hover>
					</v-col>
					<v-col
						cols="12"
						sm="6"
						md="4"
						class="d-flex align-center justify-center"
					>
						<v-hover v-slot="{ hover }">
							<div
								class="image-container d-flex flex-column align-center justify-center"
							>
								<img
									class="primary-image"
									:src="
										!hover
											? require(`../assets/who/caioColor.png`)
											: require(`../assets/who/caioColor.png`)
									"
									alt="Caio Estudante"
									style="width: 324px; height: 274px"
								/>
								<p
									id="paragraph3"
									:style="{ color: !hover ? `#4D4D4D` : `#F15C24` }"
									style="color: #4d4d4d; font-size: 22px; font-weight: 800"
								>
									Caio
								</p>
								<p
									style="
										color: #4d4d4d;
										font-size: 15px;
										font-weight: 600;
										margin-top: -20px;
									"
								>
									Estudante
								</p>
							</div>
						</v-hover>
					</v-col>

					<v-col
						cols="12"
						sm="6"
						md="4"
						class="d-flex align-end justify-center"
					>
						<v-hover v-slot="{ hover }">
							<div
								class="image-container d-flex flex-column align-center justify-center"
							>
								<img
									class="primary-image"
									:src="
										!hover
											? require(`../assets/who/maria.png`)
											: require(`../assets/who/maria.png`)
									"
									alt="Maria"
									style="width: 324px; height: 274px"
								/>

								<p
									id="paragraph"
									:style="{ color: !hover ? `#4D4D4D` : `#F15C24` }"
									style="color: #4d4d4d; font-size: 22px; font-weight: 800"
								>
									Maria
								</p>
								<p
									style="
										color: #4d4d4d;
										font-size: 15px;
										font-weight: 600;
										margin-top: -20px;
									"
								>
									Estagiária
								</p>
							</div>
						</v-hover>
					</v-col>

					<v-col
						cols="12"
						sm="6"
						md="4"
						class="d-flex align-start justify-center"
					>
						<v-hover v-slot="{ hover }">
							<div
								class="image-container d-flex flex-column align-center justify-center"
							>
								<img
									class="primary-image"
									:src="
										!hover
											? require(`../assets/who/sicranoColor.png`)
											: require(`../assets/who/sicranoColor.png`)
									"
									alt="Sicrano"
									style="width: 324px; height: 274px"
								/>
								<p
									id="paragraph2"
									:style="{ color: !hover ? `#4D4D4D` : `#F15C24` }"
									style="color: #4d4d4d; font-size: 22px; font-weight: 800"
								>
									Sicrano
								</p>
								<p
									style="
										color: #4d4d4d;
										font-size: 15px;
										font-weight: 600;
										margin-top: -20px;
									"
								>
									Concurseiro
								</p>
							</div>
						</v-hover>
					</v-col>
					<v-col
						cols="12"
						sm="6"
						md="4"
						class="d-flex align-start justify-center"
					>
						<v-hover v-slot="{ hover }">
							<div
								class="image-container d-flex flex-column align-center justify-center"
							>
								<img
									class="primary-image"
									:src="
										!hover
											? require(`../assets/who/ticio.png`)
											: require(`../assets/who/ticio.png`)
									"
									alt="Tício"
									style="width: 324px; height: 274px"
								/>
								<p
									id="paragraph2"
									:style="{ color: !hover ? `#4D4D4D` : `#F15C24` }"
									style="color: #4d4d4d; font-size: 22px; font-weight: 800"
								>
									Tício
								</p>
								<p
									style="
										color: #4d4d4d;
										font-size: 15px;
										font-weight: 600;
										margin-top: -20px;
									"
								>
									Professor
								</p>
							</div>
						</v-hover>
					</v-col>

					<v-col
						cols="12"
						md="12"
						class="d-flex align-center justify-center mt-10"
					>
						<div
							class="d-flex align-center"
							style="gap: 20px"
						>
							<button
								class="btnblack"
								style="
									background-color: #f15c24;
									color: #fff;
									width: 210px;
									height: 40px;
									font-weight: 700;
									border-radius: 100px;
								"
								@click="scrollToSection('planos')"
							>
								Cadastre-se grátis
							</button>
							<img
								src="../assets/home/logotipo.svg"
								alt="Logo MyLegis"
								style="width: 103px; height: 25px"
							/>
						</div>
					</v-col>
				</v-row>
			</v-container>

			<!-- DEPOIMENTOS -->
			<v-container fluid>
				<v-row class="bgcarrossel inter mb-5">
					<v-col cols="12">
						<p
							style="
								color: #fff;
								font-size: 40px;
								line-height: 1;
								margin-top: 35px;
								margin-bottom: 0px;
							"
						>
							O que estão <span style="font-weight: 800">dizendo?</span>
						</p>
						<p style="color: #fff; font-size: 20px">
							Nossos usuários estão descobrindo uma nova forma de estudar as
							legislações.
						</p>
						<v-slide-group
							style="margin-top: 20px"
							:show-arrows="true"
						>
							<v-slide-item
								:class="intBreakPoint < 2 ? `mr-0` : `mr-2`"
								v-for="d in depoimentos"
								:key="d.src"
								style="max-width: calc(100vw - 72px)"
							>
								<img
									:src="d.src"
									:alt="d.alt"
								/>
							</v-slide-item>
						</v-slide-group>
						<p class="text-center mt-5">
							<button
								class="mx-auto btnorange"
								style="
									background-color: #272727;
									color: #fff;
									width: 210px;
									height: 40px;
									font-weight: 700;
									border-radius: 100px;
								"
								@click="scrollToSection('planos')"
							>
								Cadastre-se grátis
							</button>
						</p>
					</v-col>
				</v-row>
			</v-container>

			<!-- CRIE SEUS VADE MECUNS -->
			<v-container fluid>
				<v-carousel
					height="110"
					class="mb-4 mt-n5"
					v-model="showBannerDestaque1"
					cycle
					:interval="6000"
					hide-delimiters
					:show-arrows="false"
				>
					<small style="font-size: 10px !important">Patrocínio</small>
					<v-carousel-item
						v-for="b in banners2"
						:key="b.directus_files_id"
					>
						<a
							:href="b.link"
							target="_blank"
						>
							<v-img
								:src="`https://api.mylegis.com.br/assets/${b.directus_files_id}`"
								class="mx-auto mb-10"
								width="720"
								contain
								height="90"
							/>
						</a>
					</v-carousel-item>
				</v-carousel>
				<div
					class="bgvecum"
					style="border-radius: 60px"
				>
					<p
						style="
							font-weight: 500;
							font-size: 40px;
							color: #272727;
							text-align: center;
						"
					>
						Crie e personalize os seus próprios
						<span style="font-weight: 800">vade-mécuns</span>
					</p>
					<p
						style="
							color: #827f8d;
							text-align: center;
							font-weight: 700;
							font-size: 17px;
							margin-top: 20px;
						"
					>
						Meus vade-mécuns
					</p>
					<v-row class="d-flex align-center justify-center">
						<v-col
							id="beneficios"
							cols="12"
							sm="6"
							md="4"
							lg="2"
							class="d-flex align-center justify-center"
						>
							<v-card
								style="
									background-color: #f15a24;
									height: 280px;
									width: 220px;
									border-radius: 20px;
									transform: scale(1);
								"
								ref="card0"
							>
								<div class="d-flex justify-center pt-6">
									<img
										src="../assets/home/mycards.svg"
										alt="Logo MyLegis"
										style="width: 100px; height: 30px"
									/>
								</div>
								<div
									class="d-flex flex-column align-center"
									style="margin-top: 160px"
								>
									<div class="d-flex flex-column">
										<p style="color: #fff; font-size: 22px; font-weight: 800">
											Vade-mécum
										</p>
										<p
											style="
												color: #fff;
												font-size: 15px;
												font-weight: 800;
												margin-top: -20px;
											"
										>
											Tributário
										</p>
									</div>
								</div>
							</v-card>
						</v-col>
						<v-col
							cols="12"
							sm="6"
							md="4"
							lg="2"
							class="d-flex align-center justify-center"
						>
							<v-card
								style="
									background-color: #f19f24;
									height: 280px;
									width: 220px;
									border-radius: 20px;
								"
								class="d-flex flex-column"
								ref="card1"
							>
								<div class="d-flex justify-center pt-6">
									<img
										src="../assets/home/mycards.svg"
										alt="Logo MyLegis"
										style="width: 100px; height: 30px"
									/>
								</div>
								<div
									class="d-flex flex-column align-center"
									style="margin-top: 160px"
								>
									<div class="d-flex flex-column">
										<p style="color: #fff; font-size: 22px; font-weight: 800">
											Vade-mécum
										</p>
										<p
											style="
												color: #fff;
												font-size: 15px;
												font-weight: 800;
												margin-top: -20px;
											"
										>
											Administrativo e Civil
										</p>
									</div>
								</div>
							</v-card>
						</v-col>
						<v-col
							cols="12"
							sm="6"
							md="4"
							lg="2"
							class="d-flex align-center justify-center"
						>
							<v-card
								style="
									background-color: #60c93b;
									height: 280px;
									width: 220px;
									border-radius: 20px;
								"
								class="d-flex flex-column"
								ref="card2"
							>
								<div class="d-flex justify-center pt-6">
									<img
										src="../assets/home/mycards.svg"
										alt="Logo MyLegis"
										style="width: 100px; height: 30px"
									/>
								</div>
								<div
									class="d-flex flex-column align-center"
									style="margin-top: 160px"
								>
									<div class="d-flex flex-column">
										<p style="color: #fff; font-size: 22px; font-weight: 800">
											Vade-mécum
										</p>
										<p
											style="
												color: #fff;
												font-size: 15px;
												font-weight: 800;
												margin-top: -20px;
											"
										>
											Prova da OAB
										</p>
									</div>
								</div>
							</v-card>
						</v-col>
						<v-col
							cols="12"
							sm="6"
							md="4"
							lg="2"
							class="d-flex align-center justify-center"
						>
							<v-card
								style="
									background-color: #269fba;
									height: 280px;
									width: 220px;
									border-radius: 20px;
								"
								class="d-flex flex-column"
								ref="card3"
							>
								<div class="d-flex justify-center pt-6">
									<img
										src="../assets/home/mycards.svg"
										alt="Logo MyLegis"
										style="width: 100px; height: 30px"
									/>
								</div>
								<div
									class="d-flex flex-column align-center"
									style="margin-top: 160px"
								>
									<div class="d-flex flex-column">
										<p style="color: #fff; font-size: 22px; font-weight: 800">
											Vade-mécum
										</p>
										<p
											style="
												color: #fff;
												font-size: 15px;
												font-weight: 800;
												margin-top: -20px;
											"
										>
											Universitário
										</p>
									</div>
								</div>
							</v-card>
						</v-col>
						<v-col
							cols="12"
							sm="12"
							md="4"
							lg="2"
							class="d-flex align-center justify-center"
						>
							<v-card
								style="
									background-color: #f12424;
									height: 280px;
									width: 220px;
									border-radius: 20px;
								"
								class="d-flex flex-column"
								ref="card4"
							>
								<div class="d-flex justify-center pt-6">
									<img
										src="../assets/home/mycards.svg"
										alt="Logo MyLegis"
										style="width: 100px; height: 30px"
									/>
								</div>
								<div
									class="d-flex flex-column align-center"
									style="margin-top: 160px"
								>
									<div class="d-flex flex-column">
										<p style="color: #fff; font-size: 22px; font-weight: 800">
											Vade-mécum
										</p>
										<p
											style="
												color: #fff;
												font-size: 15px;
												font-weight: 800;
												margin-top: -20px;
											"
										>
											Defensoria Pública
										</p>
									</div>
								</div>
							</v-card>
						</v-col>
					</v-row>
					<v-row>
						<v-col cols="12">
							<p
								style="
									color: #272727;
									font-size: 32px;
									font-weight: 500;
									text-align: center;
								"
							>
								Sempre atualizados e na palma da sua mão.
							</p>
						</v-col>
						<v-col
							cols="12"
							md="5"
							class="d-flex align-center justify-center"
						>
							<img
								src="../assets/home/logotipo.svg"
								alt="Logo MyLegis"
								style="width: 103px; height: 25px"
							/>
							<button
								class="ml-8 btnorange"
								style="
									background-color: #272727;
									color: #fff;
									width: 210px;
									height: 40px;
									font-weight: 700;
									border-radius: 100px;
								"
								@click="scrollToSection('planos')"
							>
								Cadastre-se grátis
							</button>
						</v-col>
						<v-col
							cols="12"
							md="7"
							class="pr-16 d-flex align-center justify-center"
						>
							<v-autocomplete
								clearable
								:filter="customFilter"
								:items="legislacoes"
								:search-input.sync="search"
								:loading="loading"
								solo
								v-model="strSearchLegiscao"
								item-text="nome_lei"
								item-value="id_lei"
								color="#F15A24"
								outlined
								class="px-2 py-1 d-flex align-center justify-center ml-8"
								style="
									background-color: transparent;
									border-radius: 100px;
									width: 600px;
								"
								placeholder="Pesquise pelo número (10.406) ou palavra da ementa (Código Civil)"
								hint="Pesquise pelo número (10.406) ou palavra da ementa (Código Civil)"
								hide-details
							>
								<template v-slot:no-data>
									<v-list-item>
										<v-list-item-title>
											Pesquise pelo número ou palavra da ementa da
											<strong>legislação</strong>
										</v-list-item-title>
									</v-list-item>
								</template>

								<template v-slot:item="{ item }">
									<v-list-item-content style="max-width: 510px">
										<v-list-item-title
											v-html="highlight(item.numero_lei, search)"
										></v-list-item-title>
										<div
											class="text--primary mb-4"
											v-html="highlight(item.nome_lei, search)"
										></div>
									</v-list-item-content>
								</template>

								<template v-slot:append-item>
									<v-pagination
										v-if="totalItems > itemsPerPage"
										v-model="currentPage"
										:total-visible="7"
										:length="Math.ceil(totalItems / itemsPerPage)"
										color="#F15A24"
										@input="handlePageChange"
										class="mt-4"
									>
									</v-pagination>
								</template>
							</v-autocomplete>
						</v-col>
					</v-row>
				</div>
			</v-container>
			<!-- CANSADO DE CARREGAR -->
			<v-container fluid>
				<v-row class="mt-10">
					<v-col
						cols="12"
						md="6"
						class="d-flex align-center justify-center"
					>
						<img
							src="../assets/home/carregar.webp"
							alt="Homem carregando livros"
						/>
					</v-col>
					<v-col
						cols="12"
						md="6"
						class="d-flex flex-column justify-center"
						:class="intBreakPoint < 2 ? `align-center ` : ``"
					>
						<img
							src="../assets/home/logotipo.svg"
							alt="Logo Mylegis"
							width="150px"
							height="40px"
							class="mb-4"
						/>
						<p style="font-size: 34px; font-weight: 500; line-height: 35px">
							Cansado de
							<span style="color: #f15c24; font-weight: 800">carregar</span>
							tantos <br />
							códigos e
							<span style="color: #f15c24; font-weight: 800"
								>não ter espaço</span
							><br />
							para as suas
							<span style="color: #f15c24; font-weight: 800">anotações?</span>
						</p>
						<p
							style="
								color: #827f8d;
								font-size: 20px;
								line-height: 34px;
								font-weight: 400;
							"
						>
							A Mylegis agrupa na palma da sua mão todo o <br />
							conteúdo necessário para facilitar os seus estudos.
						</p>

						<div class="d-flex align-center flex-column">
							<div class="d-flex align-center justify-center">
								<img
									src="../assets/home/doc.svg"
									alt="Documento"
								/>
								<p
									class="ml-2 mt-2"
									style="font-size: 14px; line-height: 14px"
								>
									Insira anotações e mídias <br />em qualquer dispositivo legal
									<br />
									e
									<span style="font-weight: 700"
										>compartilhe conhecimento.</span
									>
								</p>
							</div>
							<button
								class="btnorange"
								style="
									background-color: #272727;
									color: #fff;
									width: 210px;
									height: 40px;
									font-weight: 700;
									border-radius: 100px;
								"
								@click="scrollToSection('planos')"
							>
								Cadastre-se grátis
							</button>
						</div>
					</v-col>
				</v-row>
			</v-container>

			<!-- CONTAINER PLANOS -->
			<v-container fluid>
				<v-row
					class="mt-10 back inter"
					style="padding: 40px 0"
					id="planos"
				>
					<v-col
						ref="id2"
						cols="12"
						md="9"
						class="d-flex align-center mb-5"
					>
						<h1
							style="
								color: #141414;
								font-size: 40px;
								font-weight: 500;
								line-height: 41px;
							"
						>
							<span style="font-weight: 800">Crie o seu vade-mécum</span> e
							participe agora da nossa
							<span style="font-weight: 800">rede social jurídica.</span>
						</h1>
					</v-col>
					<v-col
						cols="12"
						md="3"
						class="d-flex align-center mb-5"
					>
						<img
							src="../assets/home/myy.svg"
							width="200"
							alt="Logo Mylegis"
						/>
					</v-col>
					<v-slide-group 
						show-arrows
						class="plans-slide-group"
						style="padding: 20px 0;"
					>
						<v-slide-item
							v-for="(p, n) in plans"
							:key="n"
							v-slot="{ active, toggle }"
						>
							<v-card
								elevation="0"
								:style="{
									maxWidth: intBreakPoint < 2 ? `calc(100vw - 48px)` : `280px`,
									minWidth: intBreakPoint < 2 ? `calc(100vw - 48px)` : `280px`,
									minHeight: intBreakPoint < 2 ? `auto` : `600px`,
								}"
								style="
									background-color: #fff;
									border-radius: 20px;
									padding: 24px;
									box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
									transition: transform 0.2s ease, box-shadow 0.2s ease;
								"
								class="d-flex flex-column plan-card"
								:class="
									intBreakPoint < 2
										? `mx-0 justify-center`
										: `mx-3 justify-start`
								"
								@mouseenter="$event.currentTarget.style.transform = 'translateY(-4px)'; $event.currentTarget.style.boxShadow = '0 4px 16px rgba(0, 0, 0, 0.12)'"
								@mouseleave="$event.currentTarget.style.transform = ''; $event.currentTarget.style.boxShadow = '0 2px 8px rgba(0, 0, 0, 0.08)'"
							>
								<p style="font-size: 18px; font-weight: 700; margin-bottom: 8px; color: #141414;">{{ p.title }}</p>
								<p style="font-size: 36px; font-weight: 700; margin-top: 0; margin-bottom: 8px; line-height: 1.2;">
									{{ p.valor
									}}<span
										style="font-size: 16px; color: #f15c24; margin-left: 4px; font-weight: 600;"
										>{{ p.espaco }}</span
									>
								</p>

								<div
									class="d-flex flex-column mt-2"
									style="flex: 1; gap: 8px;"
								>
									<div
										class="d-flex align-start"
										v-for="d in p.detalhes"
										:key="p.espaco + d"
										style="margin-bottom: 4px;"
									>
										<v-icon
											class="mt-1 mr-2"
											color="#F15C24"
											size="20"
											style="flex-shrink: 0;"
											>mdi-checkbox-marked-circle</v-icon
										>
										<p style="font-weight: 600; line-height: 20px; font-size: 14px; color: #4d4d4d; margin: 0;">
											{{ d }}
										</p>
									</div>
								</div>
								<p
									v-if="p.detalhes.length === 0"
									class="text-center mt-8"
									style="font-size: 15px; line-height: 1.6em; font-weight: 600; color: #4d4d4d; flex: 1;"
								>
									Planos sob medida para a sua pessoa jurídica <br />
									entre em contato com:
									<a href="mailto:administrativo@mylegis.com.br" style="color: #f15c24;"
										>administrativo@mylegis.com.br</a
									>. <br />
									Ideal para associações mantenedoras, faculdades, cursinhos,
									escritórios de advocacia, associações do MP entre outros...
								</p>
								<a href="mailto:administrativo@mylegis.com.br" style="text-decoration: none; margin-top: auto;">
									<button
										v-if="p.detalhes.length === 0"
										style="width: 100%; height: 48px; margin-top: 16px;"
										class="btnPlanos d-flex align-center justify-center"
									>
										Enviar Email
									</button>
								</a>
								<router-link
									v-if="p.detalhes.length > 0"
									:to="p.route"
									style="text-decoration: none; margin-top: auto;"
								>
									<div class="d-flex align-center justify-center">
										<button
											style="width: 100%; height: 48px; margin-top: 16px;"
											class="btnPlanos d-flex align-center justify-center"
										>
											Começar agora
										</button>
									</div>
								</router-link>
							</v-card>
						</v-slide-item>
					</v-slide-group>

					<!-- <v-col cols="12" md="4">
            <v-card
              elevation="0"
              style="background-color: #fff; border-radius: 20px; padding: 25px"
              class="d-flex justify-center flex-column"
            >
              <p style="font-size: 20px; font-weight: 700">Plano Carreira</p>
              <p style="font-size: 40px; font-weight: 700; margin-top: -20px">
                R$14,90
                <span
                  style="font-size: 16px; color: #827f8d; margin-left: -10px"
                  >/mês 10GB</span
                >
              </p>

              <div class="d-flex flex-column mt-8">
                <div class="d-flex align-center">
                  <v-icon class="mb-4 mr-1" color="#F15C24" size="35"
                    >mdi-checkbox-marked-circle</v-icon
                  >
                  <p style="font-weight: 700; line-height: 17px">
                    Crie vários vade-mécuns
                  </p>
                </div>

                <div class="d-flex align-center">
                  <v-icon class="mb-4 mr-1" color="#F15C24" size="35"
                    >mdi-checkbox-marked-circle</v-icon
                  >
                  <p style="font-weight: 700; line-height: 17px">
                    Adicione comentários e mídias <br />
                    em cada dispositivo legal.
                  </p>
                </div>

                <div class="d-flex align-center">
                  <v-icon class="mb-4 mr-1" color="#F15C24" size="35"
                    >mdi-checkbox-marked-circle</v-icon
                  >
                  <p style="font-weight: 700; line-height: 17px">
                    Publique e comente na <br />rede social jurídica.
                  </p>
                </div>

                <div class="d-flex align-center">
                  <v-icon class="mb-4 mr-1" color="#F15C24" size="35"
                    >mdi-checkbox-marked-circle</v-icon
                  >
                  <p style="font-weight: 700; line-height: 17px">
                    Crie seus própios grupos.
                  </p>
                </div>

                <div class="d-flex align-center">
                  <v-icon class="mb-4 mr-1" color="#F15C24" size="35"
                    >mdi-checkbox-marked-circle</v-icon
                  >
                  <p style="font-weight: 700; line-height: 17px">
                    Anexe a seu vade-mécum <br />
                    conteúdos de terceiros.
                  </p>
                </div>
                <div class="d-flex align-center">
                  <v-icon class="mb-4 mr-1" color="#F15C24" size="35"
                    >mdi-checkbox-marked-circle</v-icon
                  >
                  <p style="font-weight: 700; line-height: 17px">
                    Pesquise por termos específicos nas legislações do
                    vade-mécum.
                  </p>
                </div>
                <div class="d-flex align-center">
                  <v-icon class="mb-4 mr-1" color="#F15C24" size="35"
                    >mdi-checkbox-marked-circle</v-icon
                  >
                  <p style="font-weight: 700; line-height: 17px">
                    Organize seus documentos.
                  </p>
                </div>
              </div>

              <router-link
                to="/cadastro/plano-carreira"
                style="text-decoration: none"
              >
                <div class="d-flex align-center justify-center">
                  <button
                    style="width: 90%; height: 50px"
                    class="mt-5 btnPlanos d-flex align-center justify-center"
                  >
                    Começar agora
                  </button>
                </div>
              </router-link>
            </v-card>
          </v-col>
          <v-col cols="12" md="4">
            <v-card
              elevation="0"
              style="background-color: #fff; border-radius: 20px; padding: 25px"
              class="d-flex justify-center flex-column"
            >
              <div class="d-flex align-center justify-center img1920">
                <img
                  src="../assets/home/maiss.svg"
                  alt="Mais procurado por profissionais"
                  style="position: absolute; width: 50%; top: -30px"
                />
              </div>
              <p style="font-size: 20px; font-weight: 700">Plano Premium</p>
              <p style="font-size: 40px; font-weight: 700; margin-top: -20px">
                R$49,90
                <span
                  style="font-size: 16px; color: #827f8d; margin-left: -10px"
                  >/mês 50GB</span
                >
              </p>

              <div class="d-flex flex-column mt-8">
                <div class="d-flex align-center">
                  <v-icon class="mb-4 mr-1" color="#F15C24" size="35"
                    >mdi-checkbox-marked-circle</v-icon
                  >
                  <p style="font-weight: 700; line-height: 17px">
                    Crie vários vade-mécuns
                  </p>
                </div>

                <div class="d-flex align-center">
                  <v-icon class="mb-4 mr-1" color="#F15C24" size="35"
                    >mdi-checkbox-marked-circle</v-icon
                  >
                  <p style="font-weight: 700; line-height: 17px">
                    Adicione comentários e mídias em cada dispositivo legal.
                  </p>
                </div>

                <div class="d-flex align-center">
                  <v-icon class="mb-4 mr-1" color="#F15C24" size="35"
                    >mdi-checkbox-marked-circle</v-icon
                  >
                  <p style="font-weight: 700; line-height: 17px">
                    Publique e comente na rede social jurídica.
                  </p>
                </div>

                <div class="d-flex align-center">
                  <v-icon class="mb-4 mr-1" color="#F15C24" size="35"
                    >mdi-checkbox-marked-circle</v-icon
                  >
                  <p style="font-weight: 700; line-height: 17px">
                    Crie seus própios grupos.
                  </p>
                </div>

                <div class="d-flex align-center">
                  <v-icon class="mb-4 mr-1" color="#F15C24" size="35"
                    >mdi-checkbox-marked-circle</v-icon
                  >
                  <p style="font-weight: 700; line-height: 17px">
                    Anexe a seu vade-mécum conteúdos de terceiros.
                  </p>
                </div>

                <div class="d-flex align-center">
                  <v-icon class="mb-4 mr-1" color="#F15C24" size="35"
                    >mdi-checkbox-marked-circle</v-icon
                  >
                  <p style="font-weight: 700; line-height: 17px">
                    Pesquise por termos específicos nas legislações do
                    vade-mécum.
                  </p>
                </div>

                <div class="d-flex align-center">
                  <v-icon class="mb-4 mr-1" color="#F15C24" size="35"
                    >mdi-checkbox-marked-circle</v-icon
                  >
                  <p style="font-weight: 700; line-height: 17px">
                    Organize seus documentos.
                  </p>
                </div>

                <div class="d-flex align-center">
                  <v-icon class="mb-4 mr-1" color="#F15C24" size="35"
                    >mdi-checkbox-marked-circle</v-icon
                  >
                  <p
                    style="
                      font-weight: 700;
                      line-height: 25px;
                      font-size: 22px;
                      font-weight: 700;
                      color: #f15a24;
                    "
                  >
                    Crie grupos com restrição <br />
                    de divulgação de conteúdo.
                  </p>
                </div>
              </div>

              <router-link
                to="/cadastro/plano-premium"
                style="text-decoration: none"
              >
                <div class="d-flex align-center justify-center">
                  <button
                    style="width: 90%; height: 50px"
                    class="mt-5 btnPlanos d-flex align-center justify-center"
                  >
                    Começar agora
                  </button>
                </div>
              </router-link>
            </v-card>
          </v-col> -->
				</v-row>
			</v-container>

			<!-- PARTICIPE REDE SOCIAL JURIDICA -->
			<v-container fluid>
				<v-row id="sobre">
					<v-col
						cols="12"
						md="6"
						class="d-flex flex-column align-start justify-center"
					>
						<p
							style="
								font-size: 40px;
								font-weight: 800;
								line-height: 44px;
								color: #272727;
							"
						>
							Participe da primeira <br /><span
								style="color: #f15c24; font-weight: 800"
								>Rede social jurídica</span
							>
						</p>
						<p style="font-size: 20px; color: #272727; font-weight: 800">
							A diversidade de opiniões é que gera o conhecimento.
						</p>
						<p style="color: #827f8d; font-size: 20px; line-height: 24px">
							O compartilhamento de informações impulsionará <br />
							a sua vida acadêmica e profissional.
						</p>
						<div class="d-flex align-center">
							<button
								class="btnorange"
								style="
									background-color: #272727;
									color: #fff;
									width: 210px;
									height: 40px;
									font-weight: 700;
									border-radius: 100px;
								"
								@click="scrollToSection('planos')"
							>
								Cadastre-se grátis
							</button>
							<div class="d-flex align-center justify-center ml-8">
								<img
									src="../assets/home/doc.svg"
									alt="Documento"
								/>
								<p
									class="ml-2 mt-2"
									style="font-size: 14px; line-height: 14px"
								>
									Insira anotações e mídias <br />em qualquer dispositivo legal
									<br />
									e
									<span style="font-weight: 700"
										>compartilhe conhecimento.</span
									>
								</p>
							</div>
						</div>
					</v-col>
					<v-col
						cols="12"
						md="6"
						class="d-flex align-center justify-center"
					>
						<img
							src="../assets/who/grupoColor.jpg"
							width="75%"
							alt="Usuários do mylegis"
						/>
					</v-col>
				</v-row>
			</v-container>
		</v-main>
		<v-footer
			class="inter"
			style="background-color: #fff; border-top: 1px solid #827f8d"
		>
			<v-row class="d-flex align-start mt-3">
				<v-col
					cols="12"
					md="6"
				>
					<div
						class="d-flex flex-column"
						:class="intBreakPoint > 2 ? `ml-15` : ``"
					>
						<img
							src="../assets/home/myy.svg"
							alt="Logo Mylegis"
							style="width: 259px; height: 65px"
						/>
						<p style="color: #827f8d">
							Muito mais do que só um vade-mécum digital.
						</p>
						<div
							class="d-flex"
							style="gap: 5px"
						>
							<a
								href="https://www.instagram.com/mylegisoficial/"
								target="_blank"
								><img
									src="../assets/home/linkinsta.svg"
									alt="Instagram"
							/></a>
							<a
								href="https://www.facebook.com/people/Mylegis/61556276132184/"
								target="_blank"
								><img
									src="../assets/home/linkface.svg"
									alt="Facebook"
							/></a>
							<!-- <img src="../assets/home/linktwitter.svg" alt="Twitter" class="mb-2">
                            <img src="../assets/home/linkyt.svg" alt="Youtube" class="mb-2"> -->
						</div>
						<p>
							<a href="mailto:administrativo@mylegis.com.br"
								>administrativo@mylegis.com.br</a
							>
						</p>
					</div>
				</v-col>
				<v-col
					cols="12"
					sm="6"
					md="2"
					class="d-flex flex-column justify-center"
				>
					<p style="font-weight: 700">Páginas</p>
					<p
						class="hoverfooter"
						style="cursor: pointer"
						@click="scrollToSection('home')"
					>
						Home
					</p>
					<p
						class="hoverfooter"
						style="cursor: pointer"
						@click="scrollToSection('planos')"
					>
						Planos
					</p>
					<p
						class="hoverfooter"
						style="cursor: pointer"
						@click="
							verContato = true;
							typeSelected = 2;
						"
					>
						Contato
					</p>
					<p
						class="hoverfooter"
						style="cursor: pointer"
						@click="
							verContato = true;
							typeSelected = 0;
						"
					>
						Sugerir Legislação
					</p>
				</v-col>
				<v-col
					cols="12"
					sm="6"
					md="4"
					class="d-flex flex-column justify-center"
				>
					<p style="font-weight: 700">FAQ</p>
					<p
						v-for="(f, index) in faq"
						:key="f.funcao"
						class="hoverfooter"
						style="cursor: pointer"
						@click="
							showFaq = index;
							verFaq = true;
						"
					>
						{{ f.funcao }}
					</p>
				</v-col>
			</v-row>
		</v-footer>

		<!-- <v-col cols="3" md="12" class="d-flex align-center justify-center">
            <a href="https://api.whatsapp.com/send?phone=5512974059209" target="_blank" style="text-decoration: none">
                <v-card class="d-flex flex-column align-center justify-center card" ref="card0"
                    :style="{ transform: transformCard0 }">
                    <p>fssdfsfsfsf</p>
                </v-card>
            </a>
        </v-col> -->
		<v-dialog
			v-model="verLei"
			transition="dialog-bottom-transition"
			max-width="600"
		>
			<v-card>
				<v-card-title
					>Ver Lei <v-spacer></v-spacer
					><v-btn
						text
						@click="
							strSearchLegiscao = null;
							verLei = false;
						"
						><v-icon>mdi-close</v-icon></v-btn
					>
				</v-card-title>
				<v-card-text>
					<DynamicScroller
						id="conteudos"
						ref="conteudos"
						class="scroller"
						:items="conteudosLegislacao"
						key-field="id_reg"
						:min-item-size="15"
					>
						<template v-slot:default="{ item, index, active }">
							<DynamicScrollerItem
								:item="item"
								:data-index="index"
								:active="active"
								:size-dependencies="[item.conteudo]"
							>
								<v-col
									class="rowAnnotation"
									cols="12"
								>
									<p
										v-html="item.conteudo"
										:id="item.id_reg"
									></p>
								</v-col>
							</DynamicScrollerItem>
						</template>
					</DynamicScroller>
				</v-card-text>
				<v-card-actions class="w-100 d-flex justify-center align-center">
					<p class="d-flex justify-center align-center intra">
						Para ver a legislação completa
						<button
							class="ml-8 btnorange"
							style="
								background-color: #272727;
								color: #fff;
								width: 210px;
								height: 40px;
								font-weight: 700;
								border-radius: 100px;
							"
						>
							Cadastre-se grátis
						</button>
					</p>
				</v-card-actions>
			</v-card>
		</v-dialog>
		<v-dialog
			v-model="verFaq"
			width="700"
		>
			<v-card
				v-if="showFaq != null"
				class="d-flex flex-column justify-center pa-4 inter"
				style="border-radius: 0.5rem"
			>
				<p
					style="
						color: #47425d;
						font-size: 32px;
						font-weight: 800;
						line-height: 38px;
					"
				>
					{{ faq[showFaq].funcao }}
				</p>
				<iframe
					width="100%"
					height="350"
					:src="faq[showFaq].link"
					v-if="faq[showFaq].link"
					:title="faq[showFaq].funcao"
					frameborder="0"
					allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
					allowfullscreen
				></iframe>
				<!-- <p style="color: #47425D; font-size: 19px; font-weight: 400; width:100%" v-html="faq[showFaq].pergunta"></p> -->
				<p
					style="color: #47425d; font-size: 15px; font-weight: 400"
					v-html="faq[showFaq].resposta"
				></p>
				<div
					class="d-flex align-center justify-space-between mt-16"
					style="width: 100%"
				>
					<p style="color: #47425d">
						Ainda em dúvidas?
						<span
							style="font-weight: 700; cursor: pointer"
							@click="
								verContato = true;
								typeSelected = 1;
							"
							>Entre em contato</span
						>
					</p>
					<button
						class="btnorange"
						@click="
							scrollToSection('planos');
							verFaq = false;
						"
						style="
							color: #fff;
							background-color: #2c2c2c;
							border-radius: 100px;
							width: 210px;
							height: 40px;
							font-weight: 700;
						"
					>
						Cadastre-se grátis
					</button>
				</div>
			</v-card>
		</v-dialog>
		<v-dialog
			v-model="verContato"
			width="700"
		>
			<v-card>
				<v-card-title class="d-flex justify-space-between">
					<p class="mb-0">
						{{
							contactTypes[typeSelected].tipo.charAt(0).toUpperCase() +
							contactTypes[typeSelected].tipo.slice(1)
						}}
					</p>
					<v-btn
						@click="verContato = false"
						icon
					>
						X
					</v-btn>
					<v-card-text>
						<v-text-field
							prepend-inner-icon="mdi-account"
							color="#f57029"
							filled
							v-model="contato.nome"
							hide-details
							label="Nome"
						/>
						<v-text-field
							prepend-inner-icon="mdi-mail"
							color="#f57029"
							filled
							v-model="contato.email"
							hide-details
							label="Email"
						/>
						<v-textarea
							clearable
							filled
							v-model="contato.mensagem"
							color="#f57029"
							:label="contactTypes[typeSelected].title"
						/>
					</v-card-text>
				</v-card-title>
				<v-card-actions class="d-flex justify-center">
					<v-btn
						@click="sendSugestion"
						color="#F15A24"
						style="color: white"
						>Enviar</v-btn
					></v-card-actions
				>
			</v-card>
		</v-dialog>
	</v-container>
</template>

<style scoped>
	.v-card--reveal {
		align-items: center;
		bottom: 0;
		justify-content: center;
		background-color: #f15a24;
		opacity: 0.95;
		position: absolute;
		border-radius: 5px;
		padding: 15px;
		width: 100%;

		font-size: 22px;
	}

	a {
		color: #f15a24 !important;
		text-decoration: none;
	}

	a:hover {
		text-decoration: underline;
	}

	.scroller {
		height: 500px;
		overflow-y: auto;
		/* border: 2px dashed rgba(132, 8, 8, 0.406); */
	}

	@media (min-device-width: 355px) and (max-device-width: 730px) {
		.sizeCardMob {
			width: 100% !important;
		}

		/* 
    .padMobile {
        padding: 20px 10px !important;
    } */

		.minMaxMobile {
			min-height: 400px !important;
			max-height: 400px !important;
		}

		body,
		html {
			overflow-x: hidden !important;
		}
	}

	@media (min-device-width: 1800px) and (max-device-width: 2000px) {
		.img1920 {
			position: absolute;
			width: 90%;
			top: -10px;
		}
	}

	.hoverblack:hover {
		background-color: #000;
	}

	.bgcard {
		background-image: url('../assets/home/fundocard.webp') !important;
		background-repeat: no-repeat !important;
		background-size: contain;
	}

	.hoverfooter:hover {
		color: #f15c24;
	}

	.btnPlanos {
		background-color: #272727 !important;
		color: #fff !important;
		letter-spacing: initial !important;
		font-weight: 600 !important;
		font-size: 15px !important;
		border-radius: 50px !important;
		padding: 0 !important;
		border: none;
		cursor: pointer;
		transition: background-color 0.2s ease;
	}

	.btnPlanos:hover {
		background-color: #f15c24 !important;
	}

	.plan-card {
		display: flex;
		flex-direction: column;
	}

	.plans-slide-group {
		width: 100%;
	}

	.plans-slide-group .v-slide-group__content {
		gap: 16px;
	}

	@media (min-width: 960px) {
		.plans-slide-group .v-slide-item {
			margin-right: 16px;
		}
	}

	.bgg {
		background-image: url('../assets/home/head.webp');
		background-repeat: no-repeat;
		background-size: cover;
		background-attachment: fixed;
		background-position: center;
	}

	.fundomob {
		background-image: url('../assets/home/fundomob.webp');
		background-repeat: no-repeat;
		background-size: cover;
		background-position: center;
	}

	.bgvecum {
		background-image: url('../assets/home/vaade.webp');
		background-repeat: no-repeat;
		background-size: cover;
		background-position: center;
	}

	.bgcarrossel {
		background-image: url('../assets/home/carrossel.webp');
		background-repeat: no-repeat;
		background-size: cover;
		background-position: center;
	}

	.back {
		background-image: url('../assets/home/pricing.webp');
		background-repeat: no-repeat;
		background-size: cover;
	}

	.hovernavbar:hover {
		color: #000 !important;
	}

	.hovernavbar-scrolled:hover {
		color: #f15c24 !important;
	}

	.btnblack:hover {
		background-color: #2c2c2c !important;
	}

	.btnorange:hover {
		background-color: #f15c24 !important;
	}

	.mylegisBkg {
		background: rgb(241, 90, 36);
		background: linear-gradient(
			90deg,
			rgba(241, 90, 36, 1) 0%,
			rgba(247, 147, 30, 1) 100%
		);
	}

	.theme--light.v-list-item--active:hover::before,
	.theme--light.v-list-item--active::before {
		opacity: 0;
	}

	.navbar-black {
		background-color: #272727 !important;
	}

	.button-black {
		background-color: #f15c24 !important;
		color: #fff !important;
	}

	.image-container {
		position: relative;
	}

	.secondary-image {
		visibility: hidden;
		opacity: 0;
		position: absolute;
		top: 0;
		left: 0;
	}

	.primary-image:hover + .secondary-image {
		visibility: visible;
		opacity: 1;
	}

	.card {
		width: 200px;
		height: 250px;
		background-color: #fff;
		border-radius: 10px;
		transition: transform 0.25s ease-out;
	}

	@keyframes smoothRotation {
		0% {
			transform: perspective(1000px) rotateX(0deg) rotateY(0deg);
		}

		100% {
			transform: perspective(1000px) rotateX(var(--rx)) rotateY(var(--ry));
		}
	}

	.card:hover {
		animation: smoothRotation 0.25s ease-out forwards;
	}

	/* @media (max-width: 786px) {
	body, html {
	overflow-x: hidden !important;
} */
</style>

<script>
	import { DynamicScroller, DynamicScrollerItem } from 'vue-virtual-scroller';
	import 'vue-virtual-scroller/dist/vue-virtual-scroller.css';
	import { ref, watch } from 'vue';
	import { useMouseInElement } from '@vueuse/core';
	import axios from 'axios';
	// import PesquisaLegislacao from "../components/PesquisaLegislacao.vue";
	import lawStore from '../stores/law.js';

	export default {
		name: 'home',
		components: { DynamicScroller, DynamicScrollerItem },
		data() {
			return {
				banners: [],
				banners2: [],
				showBannerDestaque: 0,
				showBannerDestaque1: 0,
				drawer: null,
				isScrolled: false,
				verFaq: false,
				verContato: false,
				currentPage: 1,
				itemsPerPage: 10,
				totalItems: 0,
				contato: { nome: '', email: '', mensagem: '' },
				isMouseOverImage: false,
				isHovered: false,
				strSearchLegiscao: null,
				conteudosLegislacao: [],
				verLei: false,
				search1: null,
				search: null,
				loading: false,
				legislacoes: [],
				showFaq: null,
				items: [],
				faq: [],
				typeSelected: 0,
				contactTypes: [
					{
						tipo: 'sugerir',
						title: 'Indique a legislação que gostaria de ver na Mylegis',
					},
					{ tipo: 'dúvida', title: 'Escreva aqui a sua dúvida ou sugestão' },
					{ tipo: 'contato', title: 'Escreva aqui a sua mensagem ou sugestão' },
				],
				parceiros: [],
				plans: [
					{
						title: 'Plano Iniciante',
						valor: 'Grátis',
						espaco: '10MB',
						route: '/cadastro/plano-free',
						detalhes: [
							'Crie até 3 vade-mécuns',
							'Adicione comentários e mídias em cada dispositivo legal (posts privados).',
							'Publique posts entre amigos e grupos de amigos.',
							'Curta e comente posts públicos na rede social jurídica.',
							'Participe de grupos.',
							'Importe posts de terceiros para seus vade-mécuns.',
							'Pesquise por termos específicos nas legislações do vade-mécum.',
							'Organize seus documentos.',
						],
					},
					{
						title: 'Plano Carreira',
						valor: 'R$14,90',
						espaco: '/mês 10GB',
						route: '/cadastro/plano-carreira',
						detalhes: [
							'Crie até 10 vade-mécuns',
							'Adicione comentários e mídias em cada dispositivo legal (posts privados).',
							'Publique posts públicos (para toda a plataforma) entre amigos e grupos de amigos.',
							'Curta e comente posts públicos na rede social jurídica.',
							'Crie e participe de grupos.',
							'Importe posts de terceiros para seus vade-mécuns.',
							'Crie e importe vade-mécuns públicos.',
							'Pesquise por termos específicos nas legislações do vade-mécum.',
							'Organize seus documentos.',
						],
					},
					{
						title: 'Plano Premium',
						valor: 'R$49,90',
						espaco: '/mês 50GB',
						route: '/cadastro/plano-carreira',
						detalhes: [
							'Crie até 50 vade-mécuns',
							'Adicione comentários e mídias em cada dispositivo legal (posts privados).',
							'Publique posts públicos (para toda a plataforma) entre amigos e grupos de amigos.',
							'Curta e comente posts públicos na rede social jurídica.',
							'Crie e participe de grupos.',
							'Crie grupos com restricao de divulgação de conteudo.',
							'Importe posts de terceiros para seus vade-mécuns.',
							'Crie e importe vade-mécuns públicos.',
							'Pesquise por termos específicos nas legislações do vade-mécum.',
							'Organize seus documentos.',
						],
					},
					{
						title: 'Plano Legislativo',
						valor: 'R$499,90',
						espaco: '/mês 100GB',
						route: '/cadastro/plano-legislativo',
						detalhes: [
							'Crie até 100 vade-mécuns',
							'Adicione comentários e mídias em cada dispositivo legal (posts privados).',
							'Publique posts públicos (para toda a plataforma) entre amigos e grupos de amigos.',
							'Curta e comente posts públicos na rede social jurídica.',
							'Crie e participe de grupos.',
							'Crie grupos com restricao de divulgação de conteudo.',
							'Importe posts de terceiros para seus vade-mécuns.',
							'Crie e importe vade-mécuns públicos.',
							'Pesquise por termos específicos nas legislações do vade-mécum.',
							'Organize seus documentos.',
							'Acesso prioritário a novas funcionalidades.',
						],
					},
					{
						title: 'Plano Institucional',
						valor: '',
						espaco: 'sob consulta',
						route: '/cadastro/plano-institucional',
						detalhes: [],
					},
				],
				depoimentos: [
					{ src: require('../assets/home/d1.webp'), alt: 'Depoimento1' },
					{ src: require('../assets/home/d2.webp'), alt: 'Depoimento2' },
					{ src: require('../assets/home/d3.webp'), alt: 'Depoimento3' },
					{ src: require('../assets/home/d4.webp'), alt: 'Depoimento4' },
					{ src: require('../assets/home/d5.webp'), alt: 'Depoimento5' },
					{ src: require('../assets/home/d6.webp'), alt: 'Depoimento6' },
				],
			};
		},
		setup() {
			const card0 = ref(null);
			const card1 = ref(null);
			const card2 = ref(null);
			const card3 = ref(null);
			const card4 = ref(null);

			const mouse0 = useMouseInElement(card0);
			const mouse1 = useMouseInElement(card1);
			const mouse2 = useMouseInElement(card2);
			const mouse3 = useMouseInElement(card3);
			const mouse4 = useMouseInElement(card4);

			lawStore.dispatch('getLaws');
			const calculateTransform = (mouse) => {
				const MAX_ROTATION = 50;
				const ROTATION_SCALE = 1;

				const scaledRX =
					(MAX_ROTATION / 2 -
						(mouse.elementY.value / mouse.elementHeight.value) * MAX_ROTATION) *
					ROTATION_SCALE;

				const scaledRY =
					((mouse.elementX.value / mouse.elementWidth.value) * MAX_ROTATION -
						MAX_ROTATION / 2) *
					ROTATION_SCALE;

				return `perspective(${mouse.elementWidth.value}px) rotateX(${scaledRX}deg) rotateY(${scaledRY}deg)`;
			};

			watch(mouse0.x, () => {
				if (card0.value)
					card0.value.$el.style.transform = mouse0.isOutside.value
						? ''
						: calculateTransform(mouse0);
				if (card1.value)
					card1.value.$el.style.transform = mouse1.isOutside.value
						? ''
						: calculateTransform(mouse1);
				if (card2.value)
					card2.value.$el.style.transform = mouse2.isOutside.value
						? ''
						: calculateTransform(mouse2);
				if (card3.value)
					card3.value.$el.style.transform = mouse3.isOutside.value
						? ''
						: calculateTransform(mouse3);
				if (card4.value)
					card4.value.$el.style.transform = mouse4.isOutside.value
						? ''
						: calculateTransform(mouse4);
			});

			return {
				card0,
				mouse0,
				card1,
				mouse1,
				card2,
				mouse2,
				card3,
				mouse3,
				card4,
				mouse4,
			};
		},

		computed: {
			intBreakPoint() {
				switch (this.$vuetify.breakpoint.name) {
					case 'xs':
						return 0;
					case 'sm':
						return 1;
					case 'md':
						return 2;
					case 'lg':
						return 3;
					case 'xl':
						return 4;
					default:
						return 0;
				}
			},
		},

		watch: {
			strSearchLegiscao(nValue) {
				if (nValue) {
					this.loadLegislacao(nValue);
				}
			},
			search() {
				// if (this.loading) return;
				this.currentPage = 1;
				this.loadLegislacoes();
			},
		},
		mounted() {
			window.addEventListener('scroll', this.handleScroll);
			this.reloadFaq();
			this.reloadBanners();
			this.reloadBanners2();
			this.reloadParceiros();
			// this.loadLegislacoes();
		},
		beforeDestroy() {
			window.removeEventListener('scroll', this.handleScroll);
		},
		methods: {
			async reloadFaq() {
				const { data } = await this.$http.get(
					`items/faq/?filter[pagina][_eq]=home&filter[status][_eq]=published`
				);
				this.faq = data.data;
			},
			async reloadBanners() {
				const { data } = await this.$http.get(
					`/items/banners/?fields=*,banners.*&filter[local][_eq]=home-destaque`
				);
				this.banners = data.data[0].banners;
			},
			async reloadBanners2() {
				const { data } = await this.$http.get(
					`/items/banners/?fields=*,banners.*&filter[local][_eq]=home-2`
				);
				this.banners2 = data.data[0].banners;
			},
			async reloadParceiros() {
				const { data } = await this.$http.get(
					`/items/banners/?fields=*,banners.directus_files_id.*&filter[local][_eq]=parceiros`
				);
				this.parceiros = data.data[0].banners;
			},
			customFilter(item, queryText) {
				if (
					queryText.length > 4 &&
					!isNaN(queryText) &&
					queryText.indexOf('.') == -1
				) {
					queryText = queryText.replace(/(\d)(?=(\d{3})+$)/g, '$1.');
					this.search = queryText.replace(/(\d)(?=(\d{3})+$)/g, '$1.');
				}
				const textOne = item.nome_lei.toLowerCase();
				const textTwo = item.numero_lei.toLowerCase();
				const searchText = queryText.toLowerCase();

				return (
					textOne.indexOf(searchText) > -1 || textTwo.indexOf(searchText) > -1
				);
			},
			async loadLegislacao(id) {
				axios({
					url: 'items/conteudoleis/?limit=500&filter[id_lei][_eq]=' + id,
				}).then((data) => {
					// window.console.log(data.data.data)
					this.conteudosLegislacao = data.data.data;
					this.verLei = true;
				});
			},
			async loadLegislacoes() {
				this.loading = true;
				let search = this.search ? `search:"${this.search}", ` : '';
				const offset = (this.currentPage - 1) * this.itemsPerPage;

				const query = `
				query FilterByApelidosLeis {
					leis(${search ? `${search}, ` : ''}sort: ["-data_lei"], limit: ${
									this.itemsPerPage
								}, offset: ${offset}) {
					id_lei
					numero_lei
					data_lei
					nome_lei
					}
					leis_aggregated${search ? `(${search})` : ''} {
					count { id_lei }
					}
				}
				`;

				try {
					const {
						data: { data },
					} = await axios.post('https://api.mylegis.com.br/graphql', { query });

					this.legislacoes = data.leis;
					this.totalItems = data.leis_aggregated[0].count.id_lei;
				} catch (error) {
					window.console.error(error);
				} finally {
					this.loading = false;
				}
			},
			handlePageChange(newPage) {
				this.currentPage = newPage;
				this.loadLegislacoes();
			},
			goToTop() {
				// Your goToTop method implementation
			},
			handleScroll() {
				this.isScrolled = window.scrollY > 0;
				this.isHovered = false; // Reinicia o estado de hover quando o scroll é ativado
			},
			openDialog() {
				// Abre o v-dialog
				this.$refs.dialog.open();
			},
			fecharDialog() {
				// Fecha o v-dialog
				this.dialogVisivel = false;
			},
			highlight(content, query) {
				if (!query) {
					return content;
				}
				return content.replace(new RegExp(query, 'gi'), (match) => {
					return '<span class="my-orange">' + match + '</span>';
				});
			},
			scrollToSection(sectionId) {
				var section = document.getElementById(sectionId);
				if (section) {
					// Rola suavemente para a seção
					section.scrollIntoView({
						behavior: 'smooth',
					});
				}
			},
			sendSugestion() {
				this.$http
					.post('/items/contato', {
						nome: this.contato.nome,
						email: this.contato.email,
						mensagem: this.contato.mensagem,
						tipo: this.contato.tipo,
					})
					.then(() => {
						this.contato = { nome: '', email: '', mensagem: '' };
						this.verContato = false;
						alert(
							'Obrigado por nos enviar seu contato, retornaremos o mais breve possível.'
						);
					});
			},
		},
	};
</script>
